import * as React from "react";
import { TextInput, SelectInput, NumberInput, DateTimeInput, Create, ReferenceInput, AutocompleteInput, required } from "react-admin";
import { Grid } from "@mui/material";
import {
  StockTypeEnum,
  ProductSupplierEnum
} from "../../common/enum";
import Transformer from "../../common/Transformer";
import { SimpleForm} from "src/enterprise/ra-rbac";
import { StockCreateComponent } from "./StockComponent";

export const StockCreate = () => {
  const transform = (data) => {
    Transformer(data, {
      update: {
        incomingAt:
          typeof data["incoming_at"] === "string" ||
          typeof data["incoming_at"] === "undefined"
            ? data["incoming_at"]
            : (data["incoming_at"] as Date).toISOString()
      },
    });
    return data;
  };
  return (
    <Create transform={transform} component={StockCreateComponent}>
      <SimpleForm>
        <Grid container rowSpacing={1} columnSpacing={2}>
          <Grid item sm={12} md={6}>
            <ReferenceInput
              source="product"
              reference="admin/products"
            >
              <AutocompleteInput
                optionText={(record) => record.name+" "+record.sku}
                size="small"
                label="Product"
              />
            </ReferenceInput>
          </Grid>
          <Grid item sm={12} md={6}>
            <NumberInput
              validate={required()}
              source="quantity"
            />
          </Grid>
          <Grid item sm={12} md={4}>
            <TextInput source="piece" />
          </Grid>
          <Grid item sm={12} md={4}>
            <TextInput source="dyelot" />
          </Grid>
          <Grid item sm={12} md={4}>
            <DateTimeInput source="incoming_at"/>
          </Grid>
          <Grid item sm={12} md={6}>
            <SelectInput
              validate={required()}
              source="type"
              choices={StockTypeEnum}
            />
          </Grid>
          <Grid item sm={12} md={6}>
            <SelectInput
              validate={required()}
              source="supplier"
              choices={ProductSupplierEnum}
            />
          </Grid>
        </Grid>
      </SimpleForm>
    </Create>
  );
};
